import { request, requestDownload } from './httpClient.js'

export function createReportAnalysis(formData) {
  return request('/api/v1/analysis', { method: 'POST', body: formData })
}

export function getReportAnalysis(analysisId) {
  return request(`/api/v1/analysis/${encodeURIComponent(analysisId)}`)
}

export function getReport(reportId) {
  return request(`/api/v1/reports/${encodeURIComponent(reportId)}`)
}

// purpose는 서버 감사 이력에서 미리보기와 실제 다운로드 요청을 구분하는 값이다.
function requestReportPdf(reportId, templateId, purpose, options) {
  const query = new URLSearchParams()
  if (templateId) query.set('templateId', templateId)
  query.set('purpose', purpose)
  return requestDownload(`/api/v1/reports/${encodeURIComponent(reportId)}/pdf?${query}`, options)
}

export function downloadReportPdf(reportId, templateId, options = {}) {
  return requestReportPdf(reportId, templateId, 'DOWNLOAD', options)
}

export function previewReportPdf(reportId, templateId, options = {}) {
  return requestReportPdf(reportId, templateId, 'PREVIEW', options)
}

// 미리보기로 받아 둔 PDF를 브라우저에서 저장하면 서버 요청이 없으므로 클릭만 알린다.
// 기록 실패가 다운로드를 막거나 오류 알림을 띄우지 않도록 조용히 보낸다.
export function recordReportDownloadClick(reportId, templateId) {
  return request(`/api/v1/reports/${encodeURIComponent(reportId)}/download-clicks`, {
    ...jsonBody('POST', { templateId }),
    silent: true
  })
}

export function getReportTemplates() {
  return request('/api/v1/report-templates')
}

export function downloadRecommendedCoverageTemplate() {
  return requestDownload('/api/v1/reports/recommended-amount-template', {
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

export function getReportResults(page = 0, size = 20) {
  const query = new URLSearchParams({ page: String(page), size: String(size) })
  return request(`/api/v1/report-results?${query}`)
}

export function getAdminReportResults(page = 0, size = 20) {
  const query = new URLSearchParams({ page: String(page), size: String(size) })
  return request(`/api/v1/admin/report-results?${query}`)
}

const HEALTH_COVERAGE_LINKS = '/api/v1/admin/health-coverage-mappings'

export function getHealthCoverageLinks() {
  return request(HEALTH_COVERAGE_LINKS)
}

export function createHealthCoverageLink(link) {
  return request(HEALTH_COVERAGE_LINKS, jsonBody('POST', link))
}

export function updateHealthCoverageLink(id, link) {
  return request(`${HEALTH_COVERAGE_LINKS}/${encodeURIComponent(id)}`, jsonBody('PUT', link))
}

export function deleteHealthCoverageLink(id) {
  return request(`${HEALTH_COVERAGE_LINKS}/${encodeURIComponent(id)}`, { method: 'DELETE' })
}

export function getAdminAuditEvents({ page = 0, size = 20, category = '', eventType = '' } = {}) {
  const query = new URLSearchParams({ page: String(page), size: String(size) })
  if (category) query.set('category', category)
  if (eventType) query.set('eventType', eventType)
  return request(`/api/v1/admin/audit-events?${query}`)
}

function jsonBody(method, body) {
  return { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
}
